import React, {useEffect, useState} from 'react';
import {useDrag, useDrop} from "react-dnd";
import {getEmptyImage} from "react-dnd-html5-backend";

const SliderNt = ({lc, sendV, width}) => {

    const [lastVsend, setLastVsend] = useState(0)
    const [lastSend, setLastSend] = useState(Date.now())
    const [resend, setResend] = useState(false)

    const min = 0;
    const max = 127;

    const _width = width - 60

    const getPercentage = (value) => Math.round((value) * (max - min) / _width)
    const getReverse = (value) => Math.round((value) * _width / (max - min))

    const [value, setValue] = useState(getReverse(lc.v));

    useEffect(() => {
        if( (Date.now() - lastSend) > 1000) {
            const vv = getReverse(lc.v)
            setValue(vv)
        }
    }, [lc.v, lastSend]);

    useEffect(() => {
        const interval = setInterval(doSend, 100, lastVsend)
        return () => clearInterval(interval);
    }, [lastVsend, resend]);

    function handleValue(v) {

        let vx = getPercentage(v)
        let vy = v

        if (v > _width) {
            vx = max
            vy = _width
        } else if (v < 0) {
            vx = 0
            vy = 0
        }

        if (vx === 1) {
            vx = 0
        }

        setValue(vy)
        setLastVsend(vx)

        const d = Date.now()
        const diff = d - lastSend

        if (diff < 500) {
            setResend(true)
        } else {
            setLastSend(d)
            sendV(vx)
        }
    }

    function doSend(v) {
        if (resend) {
            setResend(false)
            sendV(v)
        }
    }

    const [{isDragging, opacity}, drag, dragPreview] = useDrag(() => ({
        type: 'slider',
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()

            if (dropResult) {

            }
        },
        drag: (item, monitor) => {

        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        })
    }))

    // this is to remove the dragImage on slide
    useEffect(() => {
        dragPreview(getEmptyImage())
    }, []);

    function attachRef(el) {
        drag(el)
        //drop(el)
    }

    const handleClick = (event) => {
        const {left, width} = event.currentTarget.getBoundingClientRect();
        const percentage = (event.clientX - left) / width;
        const newValue = Math.round(min + percentage * (max - min));

        handleValue(getReverse(newValue));
    };

    const handleWheel = (event) => {
        let p = Math.round(value + (-1.0 / 10) * (event.deltaY))
        handleValue(p)
    }

    const handleStop = () => {
        setValue(0)
        setLastVsend(0)
        sendV(0);
    }

    const vlocal = getPercentage(value)
    const vstate = lc.v
    const dangle = !(vlocal === vstate)
    const driving = vlocal > 0

    const anim = isDragging?'background 400ms ease-in-out':'background 400ms ease-in-out, width 400ms ease-in-out'

    const trackStyle = {
        width: `${value}px`,
        height: '32px',
        background: dangle ? "#9dd577" : "#8cc069",
        transition: anim,
    }

    const dg = _width + 'px'
    return (
        <>
            <div
                style={{
                    display: 'inline-grid',
                    gridTemplateColumns: 'auto auto',
                }}
            >
                <div
                    style={{
                        margin: '5px',
                        border: '1px solid #111111',
                        display: 'flex',
                        width: '32px',
                        height: '32px',
                        transition: 'background 500ms ease-in',
                        background: driving ? "rgba(168,143,143,0.62)" : "#798376",
                    }}
                    onClick={handleStop}
                >
                </div>
                <div
                    ref={attachRef}
                    onClick={handleClick}
                    onWheel={handleWheel}
                    onDrag={(e) => {
                        const cbr = e.target.getBoundingClientRect()
                        let dx = e.clientX - cbr.x
                        if( dx > 0) {
                            handleValue(dx)
                        }
                    }}

                    style={{
                        border: '1px solid #111111',
                        height: '32px',
                        width: dg,
                        margin: '5px',
                    }}
                >
                    <div
                        style={trackStyle}
                    ></div>
                </div>
            </div>
        </>
    );
}

// {vstate}|{vlocal}

export default SliderNt
